import { render, staticRenderFns } from "./SettingDeletePassword.vue?vue&type=template&id=2fd09fbc&scoped=true&"
import script from "./SettingDeletePassword.vue?vue&type=script&lang=js&"
export * from "./SettingDeletePassword.vue?vue&type=script&lang=js&"
import style0 from "./SettingDeletePassword.vue?vue&type=style&index=0&id=2fd09fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd09fbc",
  null
  
)

export default component.exports